export default "__VITE_ASSET__xqUNHY9X__"